

import { reactive } from 'vue'

// reactive global state for Tiptap context
const state = reactive({
  extensions: [],
  defaultLang: undefined,
  defaultFallbackLang: undefined,
  defaultMarkdownTheme: undefined,
})

export function createContext(instance = {}) {
  state.defaultLang = instance.defaultLang
  state.defaultFallbackLang = instance.defaultFallbackLang
  state.defaultMarkdownTheme = instance.defaultMarkdownTheme
  state.extensions = instance.extensions || []
}

export function useContext() {
  return { state }
}